var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-3d-container",style:({ height: this.slideHeight + 30 + 'px' })},[_c('div',{staticClass:"carousel-3d-slider",style:({
      width: this.slideWidth + 'px',
      height: this.slideHeight + 'px',
    })},[_vm._t("default")],2),(_vm.controlsVisible)?_c('controls',{attrs:{"next-html":_vm.controlsNextHtml,"prev-html":_vm.controlsPrevHtml,"width":_vm.controlsWidth,"height":_vm.controlsHeight}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }